import script from "./reportAi.vue?vue&type=script&setup=true&lang=js"
export * from "./reportAi.vue?vue&type=script&setup=true&lang=js"

import "./reportAi.vue?vue&type=style&index=0&id=6d0a702c&lang=less"

const __exports__ = script;

export default __exports__